export default "__VITE_ASSET__Cs3Nbpbq__"